import LPContainer from '~/components/LandingPage/LPContainer'
import { TypographyH2 } from '~/core/ui/Heading'
import { FC, ReactNode } from 'react'
import { cn } from '~/core/ui/utils'

interface Props {
  className?: string
  title: string
  description: string | ReactNode
  openLink?: ReactNode
  image: ReactNode
  textPosition?: 'left' | 'right' | 'top' | 'bottom'
}

const FeatureBlock: FC<Props> = ({
  title,
  description,
  className,
  openLink,
  image,
  textPosition = 'top'
}) => {
  const isDisplayInRow = textPosition === 'left' || textPosition === 'right'

  return (
    <LPContainer
      className={cn(
        `flex gap-7`,
        isDisplayInRow ? 'tablet:gap-[125px]' : 'tablet:gap-[50px]',
        {
          'flex-col tablet:flex-row': textPosition === 'left',
          'flex-col tablet:flex-row-reverse': textPosition === 'right',
          'flex-col': textPosition === 'top',
          'flex-col-reverse': textPosition === 'bottom'
        },
        className
      )}>
      <div
        className={cn(' flex flex-col gap-6 tablet:gap-20 justify-center', {
          'tablet:w-[494px]': isDisplayInRow
        })}>
        <div
          className={cn('flex flex-col gap-7 tablet:gap-9', {
            'tablet:flex-row tablet:items-end tablet:justify-between':
              !isDisplayInRow
          })}>
          <div className="flex flex-col gap-5 tablet:gap-4 flex-1 max-w-[800px]">
            <TypographyH2 className="text-[31px] leading-[36px] tablet:text-[37px] tablet:leading-[42px] text-gray-900 font-medium">
              {title}
            </TypographyH2>
            <div className="text-gray-700 text-base font-normal whitespace-pre-wrap">
              {description}
            </div>
          </div>
          {openLink}
        </div>
      </div>
      <div className="flex-1">{image}</div>
    </LPContainer>
  )
}

export default FeatureBlock
